export const joinArraysWithConjunction = (array: string[], locale = "en"): string => {
    const formatter = new Intl.ListFormat(locale, { style: 'long', type: 'conjunction' });
    return formatter.format(array);
};